import { ModelsLibraryView } from "./_components";

export default function ContentModelsLibraryPage() {
  return <ModelsLibraryView />;
}
